import { ENV } from "@env";

/**
 * Safely joins URL segments ensuring exactly one `/` between them
 */
const joinUrl = (base, path) => {
    if (!path) {
        return base;
    }

    return `${base.replace(/\/+$/, "")}/${path.replace(/^\/+/, "")}`;
};

/**
 * Returns full public base URL with optional path
 */
export const getPublicBaseUrl = (path = "") => {
    const base = ENV.BASE_URL || "/";

    if (typeof window === "undefined") {
        return joinUrl(base, path);
    }

    const originWithBase = joinUrl(window.location.origin, base);

    return joinUrl(originWithBase, path);
};

/**
 * Builds engagement-specific redirection URL
 */
export const getRedirectionUrl = (tenantId, path = "") => {
    return getPublicBaseUrl(`engagements/${tenantId}${path}`);
};

/**
 * Returns base URL only (used in router basename etc.)
 */
export const getBaseUrl = () => ENV.BASE_URL || "/";
